import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Box, Typography, TextField, Button, InputAdornment
} from '@mui/material';
import { formatCurrency } from '../../utils/formatUtils';

export default function EntryPaymentDialog({
  open, onClose, onSave,
  paymentEntry, paymentAmount, setPaymentAmount
}) {
  if (!paymentEntry) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>Record Payment</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2, mt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            {paymentEntry.entry_date?.split('T')[0]?.replace(/(\d{4})-(\d{2})-(\d{2})/, '$2/$3/$1')} - {paymentEntry.first_name} {paymentEntry.last_name}
          </Typography>
          <Typography variant="h6">
            Total: {formatCurrency(paymentEntry.total_pay)}
          </Typography>
        </Box>
        <TextField
          fullWidth
          type="number"
          label="Amount Paid"
          value={paymentAmount}
          onChange={(e) => setPaymentAmount(e.target.value)}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
          inputProps={{ step: '0.01', min: 0, max: parseFloat(paymentEntry.total_pay) }}
          sx={{ mb: 2 }}
        />
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Remaining: ${Math.max(0, parseFloat(paymentEntry.total_pay) - (parseFloat(paymentAmount) || 0)).toFixed(2)}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            size="small"
            variant="outlined"
            color="success"
            onClick={() => setPaymentAmount(parseFloat(paymentEntry.total_pay).toFixed(2))}
          >
            Mark Fully Paid
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="warning"
            onClick={() => setPaymentAmount('0.00')}
          >
            Mark Unpaid
          </Button>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onSave}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
